import { useSelector } from "react-redux";
import {
  selectCurrencyCode,
  selectCurrencySymbol,
} from "../reduxFolder/selectors/globalSelectors";

// Display currency for every place the app renders a currency sign.
// Resolution lives in selectCurrencySymbol/-Code: the account's `currency`
// from /client_api/user wins, the partner config is the pre-login fallback,
// unknown codes degrade to the code itself. Non-hook code (formik factories,
// sagas, connect) should use those selectors directly.
export const useCurrencySymbol = (): string =>
  useSelector(selectCurrencySymbol);

// ISO code counterpart for the few labels that print the code ("USD").
export const useCurrencyCode = (): string => useSelector(selectCurrencyCode);
